<template>
<main   class="c-home u-viewport-fit-h u-overflow-h u-bg--brand-dark is-first" @touchstart="onTouchDown" @touchmove="onTouchMove" @touchend="onTouchEnd" @DOMMouseScroll="onMouseWheel" @mousewheel="onMouseWheel">
    <div class="c-home__nav u-absolute u-pos-l u-pos-y-center u-hide@sm" :style="myStylesNavHeight">
        <div class="c-home__nav__track u-absolute u-pos-tl u-fit-w" :style="myStylesTransform1">
            <div class="c-home__nav__track__panel o-wrapper--panel u-fit u-bg--brand-blue-dark"></div>
          </div>
    </div>
    <div class="c-home__nav u-absolute u-pos-r u-pos-y-center js-nav u-hide@sm">
        <div class="c-home__nav__track u-absolute u-pos-tl u-fit-w" :style="'transform: translateY('+100 *activeRollOverIndex+'%) translateZ(0)'" >
            <div class="c-home__nav__track__panel c-home__nav__track__panel--right o-wrapper--panel u-fit u-bg--brand-blue-dark"></div>
        </div>
        <ul class="o-list u-relative u-inline-block" @mouseover="onMenuOver"  @mouseout="onMenuOut" >
            <li class="c-home__nav__item u-cursor-pointer" v-for="(item, index)  in  globalContent.slides"  :class="{'is-active':activeIndex===index}" @mouseover="onDotOver"  @mouseout="onDotOut"  @click="onDotClick(index)">
                <span class="c-home__nav__dot u-inline-block u-valign-middle u-bg--white u-marg-r-md"></span>
                <span class="c-home__nav__label t-text--xxs t-text--base-bold u-inline-block u-valign-middle u-color--alpha-white">{{'0'+(index)}}</span>
            </li>
          </ul>
    </div>
    <button class="c-home__scroll-btn c-btn-scroll  u-pos-x-center t-btn u-absolute u-inline-block u-marg-b-vh1of12 u-marg-b-md@sm"  @click="onNextSlide">
          <img src="../../assets/medias/images/MainLogoWhite -arrow-white2.svg"  width="32px" >
    </button>

    <app-home-slide  data-color="clear" inline-template  class="c-home__section o-wrapper--valign u-fit u-overflow-h u-bg--brand-blue-dark js-header-panel" :content="content"  :IsTolltipPopDisabled="IsTolltipPopDisabledGlob"  :headerPageSize="headerPageSize"  :activeIndex="activeIndex"   :navOffsetTop="navOffsetTop"     :indexSS="0"   :hasVideo="!0"  >

  <div class="o-wrapper--valign u-fit">

          <div class="c-home__section__bar c-home__section__bar--x u-absolute u-fit-w u-bg--brand-dark u-hide@sm"></div>
          <div class="c-home__section__bar c-home__section__bar--y u-absolute u-pos-tr u-fit-h u-bg--brand-dark u-hide@sm"></div>
          <div class="c-home__section__bar c-home__section__bar--x u-absolute u-fit-w u-bg--brand-dark u-hide@sm"></div>
          <div class="c-home__section__bar c-home__section__bar--y u-absolute u-pos-bl u-fit-h u-bg--brand-dark u-hide@sm"></div>
          <span class="c-home__section__chapter t-text--xxs t-text--base-bold u-absolute u-color--alpha-white u-hide@sm">{{'0'+(indexSS)}}</span>
          <div class="c-page__header o-wrapper--panel" :style="myStylesTransform2">
              <video  muted="muted" poster="../../assets/medias/videos/videoPoster.jpg" loop="loop" playsinline="" autoplay="autoplay" class="u-absolute u-pos-tl js-video" :style="myStylesWidthHeight">
                  <source type="video/mp4" src="../../assets/medias/videos/home-02.mp4" />
                  <source type="video/webm" src="../../assets/medias/videos/home-02.webm" />

              </video>
          </div>
          <div class="c-puzzle o-wrapper--panel u-fit u-overflow-h">
              <div class="c-puzzle__piece u-absolute" style="background-color: rgb(51,51,51); opacity: 0.2;"></div>
              <div class="c-puzzle__piece u-absolute" style="background-color: rgb(51, 51, 51); opacity: 0.2;"></div>
              <div class="c-puzzle__piece u-absolute" style="background-color: rgb(51, 51, 51); opacity: 0.2;"></div>
              <div class="c-puzzle__piece u-absolute" style="background-color: rgb(51, 51, 51); opacity: 0.29;"></div>
              <div class="c-puzzle__piece u-absolute" style="background-color: rgb(51, 51, 51); opacity: 0.29;"></div>
          </div>
          <div class="u-relative u-inline-block u-valign-bottom u-marg-l-w1of12 u-marg-b-vh1of12 u-marg-b-vh3of12@sm">

              <h1 class="t-h2  t-text-lh--md u-color--white u-marg-b-vh1of12">
               <app-sliced-text-rotator  :content="content.SlideRotatorText" :timer="4"></app-sliced-text-rotator>
             </h1>
          </div>
          <div class="c-home__line-aside u-absolute u-bg--white" :style="stylesHeight1"></div>
          <div class="c-home__line-aside c-home__line-aside--bottom u-absolute u-bg--white" :style="stylesHeight2"></div>
          <div class="c-home__line-aside c-home__line-aside--bottom-2 u-absolute u-bg--white" :style="stylesHeight3Bottom"></div>
      </div>
    </app-home-slide>
      <app-home-slide  inline-template  data-color="dark" class="c-home__section c-home__section--2 o-wrapper--valign u-flex u-flex-ai--center u-fit js-header-panel" :content="content"  :IsTolltipPopDisabled="IsTolltipPopDisabledGlob"      :headerPageSize="headerPageSize"   :activeIndex="activeIndex"   :navOffsetTop="navOffsetTop"     :indexSS="1"   :hasVideo="!1"  >
        <div class="o-wrapper--valign u-fit u-bg--white" >
          <div class="c-home__section__bar c-home__section__bar--x u-absolute u-fit-w u-bg--brand-dark u-hide@sm"></div>
          <div class="c-home__section__bar c-home__section__bar--y u-absolute u-pos-tr u-fit-h u-bg--brand-dark u-hide@sm"></div>
          <div class="c-home__section__bar c-home__section__bar--x u-absolute u-fit-w u-bg--brand-dark u-hide@sm"></div>
          <div class="c-home__section__bar c-home__section__bar--y u-absolute u-pos-bl u-fit-h u-bg--brand-dark u-hide@sm"></div>
           <span class="c-home__section__chapter t-text--xxs t-text--base-bold u-absolute u-color--alpha-white u-hide@sm">{{'0'+(indexSS)}}</span>

           <div class="u-absolute u-pos-tl  u-marg-t-mdvh   u-marg-t-mdvh@sm  u-zindex--3 u-marg-l-w1of6 u-marg-l-w2of8@sm u-marg-l-w3of8@xsm">
             <div class="u-w2of2 u-fit-w@md">
                  <img src="../../assets/medias/images/lgoRghPart.svg" class="c-home__section__logo u-absolute u-pos-tl  u-zindex--3">
                 <div class="u-flex t-text--sm t-text--base-bold c-Home--title-lheigt ">
                      <span class="c-number-offset--home t-text--xl--Light   c-home-u-color--gray u-absolute u-pos-bl u-marg-b-xs3@sm">{{'0'+(indexSS)}}</span>
                      <span class="c-home__section__coverage__subsidtitleText  c-home-u-color--gray">{{content.second_slide_subtitle}}</span>
                     </div>
                 </div>
           </div>

            <div class="c-home__section__fade  u-w9of12   u-w9of12@lg u-fit-w@sm">
              <div class="u-marg-l-w1of9 u-marg-l-0@sm u-w1of2  u-fit-w@sm u-pad-l-w1of9 u-pad-x-w1of12@sm">
                      <p class="c-home__section__description u-w2of2 t-text--xxl t-text--roman u-color--gray u-w2of2@sm" style="margin-bottom:28px;" v-html="content.second_slide_content"></p>
                      <p class="c-home__section__description u-w2of2 t-text--md u-color--gray u-w2of2@sm" v-html="content.second_slide_content2"></p>
              </div>
            </div>
            <div class="u-relative u-inline-block u-valign-top u-fit-h u-bg--brand-dark u-overflow-h u-w3of12 u-hide@sm">
                <img src="../../assets/medias/images/home-01.jpg" class="u-fit u-bg--black u-object-fit-cover">

              </div>
              <div class="c-home__line-aside u-absolute u-bg--white" :style="stylesHeight1"></div>
              <div class="c-home__line-aside c-home__line-aside--bottom u-absolute u-bg--white" :style="stylesHeight1"></div>
              </div>
          </app-home-slide>
          <app-home-slide  inline-template  data-color="clear" class="c-home__section o-wrapper--valign u-flex u-flex-ai--center u-flex-jc--center u-fit u-overflow-h u-bg--black js-header-panel"   :IsTolltipPopDisabled="IsTolltipPopDisabledGlob"     :content="content"       :headerPageSize="headerPageSize"   :activeIndex="activeIndex"   :navOffsetTop="navOffsetTop"     :indexSS="2"   :hasVideo="!1"  >
            <div class="o-wrapper--valign u-fit u-bg--white" >
              <div class="c-home__section__bar c-home__section__bar--x u-absolute u-fit-w u-bg--brand-dark u-hide@sm"></div>
              <div class="c-home__section__bar c-home__section__bar--y u-absolute u-pos-tr u-fit-h u-bg--brand-dark u-hide@sm"></div>
              <div class="c-home__section__bar c-home__section__bar--x u-absolute u-fit-w u-bg--brand-dark u-hide@sm"></div>
              <div class="c-home__section__bar c-home__section__bar--y u-absolute u-pos-bl u-fit-h u-bg--brand-dark u-hide@sm"></div>
               <span class="c-home__section__chapter t-text--xxs t-text--base-bold u-absolute u-color--alpha-white u-hide@sm">{{'0'+(indexSS)}}</span>
               <img src="../../assets/medias/images/logo-simple-clear.svg" class="c-home__section__logo u-absolute u-pos-tl u-marg-t-lg u-marg-l-w1of12 u-zindex--3">
               <div class="o-wrapper--panel u-zindex--1 u-fit u-bg--black">

                 <div class="c-home__section__poster__filter u-absolute u-pos-tl u-zindex--1 u-fit" style="background-color: rgb(134, 135,137);"> </div>
               </div>


                <div class="u-absolute u-pos-tl  u-marg-t-mdvh   u-marg-t-mdvh@sm  u-zindex--3 u-marg-l-w1of6 u-marg-l-w2of8@sm u-marg-l-w3of8@xsm">
                  <div class="u-w2of2 u-fit-w@md">
                       <img src="../../assets/medias/images/logo-simple-clear.svg" class="c-home__section__logo u-absolute u-pos-tl  u-zindex--3 ">
                      <div class="u-flex t-text--sm t-text--base-bold c-Home--title-lheigt ">
                           <span class="c-number-offset--home t-text--xl--Light   c-home-u-color--white u-absolute u-pos-bl u-marg-b-xs3@sm">{{'0'+(indexSS)}}</span>
                           <span class="c-home__section__coverage__subsidtitleText  u-color--white">{{content.third_slide_subtitle}}</span>
                          </div>
                      </div>
                </div>

                <div class="c-home__grain o-wrapper--panel u-zindex--2 u-fit u-pointer-none"></div>
                    <div class="c-home__section__fade u-relative u-zindex--3 u-flex u-flex-fd--column@md u-w9of12 u-w9of12@md u-fit-w@sm u-pad-x-w1of12@sm u-pad-x-w0of0@sm">
                          <div class="c-team__content u-marg-t-xxl  u-marg-t-xs@lg u-marg-t-xs@sm u-w2of2 u-w3of4@xsm u-marg-x-w1of12@sm u-w9of10@md  u-w9of10lg u-marg-t-xxl@sm" >
                              <section class="u-relative">
                                <div class="c-team__section-container u-relative u-pad-y-ultra u-pad-r-w1of12 u-pad-y-xxl@md u-pad-y-lg@sm u-pad-x-w0of0@sm">
                                    <div class="c-team__section u-marg-t-lg u-marg-t-xl@lg u-marg-t-xs@sm">
                                          <div class="u-flex u-flex-fw--wrap u-flex-jc--space-between">
                                             <a class="c-team__link c-subsidiries__link t-link  u-marg-r-sub--wmax@xl u-marg-r-sub--wmin@sm u-marg-r-cov--wmax@lg u-marg-r-sub--wmax@fullHD u-marg-top-min--subsi@xsm"  href="javascript:void(0);"  v-for="(item, index)  in content.subsidiaries_sections[0].subsidiaries"  :data-index="index"  @click="item.first_name!=''?onOpenPopin(item,index):''"  @mouseenter="onHoverPopin((item.first_name + item.last_name).replace(/\s/g,''),index)" @mouseleave="onHoverOutPopin((item.first_name+item.last_name).replace(/\s/g,''),index)" >
                                                    <div class="c-team__link__photo-container js-photo-container u-relative o-box--14by10 u-marg-b-md u-overflow-h u-force-3d is-loading" >
                                                            <div class="u-absolute u-pos-t u-zindex--2"></div>
                                                            <img class="c-team__link__photo__hover u-zindex--1 o-wrapper--panel u-fit u-object-fit-cover u-backface-hidden fade-leave-to" :id="('hover'+item.first_name + item.last_name).replace(/\s/g,'')"  :src="item.image.sizes.medium_large"     :alt="item.first_name + '  ' + item.last_name"   :title="item.first_name + '  ' + item.last_name"  @load="_onLoadMemberImage(index)"></img>
                                                            <img class="c-team__link__photo u-zindex--1 o-wrapper--panel u-fit u-object-fit-cover u-backface-hidden" :id="(item.first_name + item.last_name).replace(/\s/g,'')"  :src="item.image.sizes.medium"     :alt="item.first_name + '  ' + item.last_name"   :title="item.first_name + '  ' + item.last_name"  @load="_onLoadMemberImage(index)"></img>
                                                    </div>
                                                    <div class="u-pad-r-sm"></div>
                                             </a>
                                          </div>
                                    </div>
                                </div>
                              </section>
                          </div>
                    </div>

                    <app-team-board-popin :isActive="isBoardActive"  :content="content.subsidiaries_sections[0]" :index="0" ></app-team-board-popin>
                    <app-team-popin   :content="popinContent"  :title="popinTitle" :index="0"  :isActive="isPopinActive"  ></app-team-popin>


                  <div class="c-home__line-aside u-absolute u-bg--white" :style="stylesHeight1"></div>
                  <div class="c-home__line-aside c-home__line-aside--bottom u-absolute u-bg--white" :style="stylesHeight1"></div>
                  </div>
              </app-home-slide>
              <app-home-slide  inline-template  data-color="dark" class="c-home__section o-wrapper--valign u-flex u-flex-ai--center u-flex-jc--center u-fit u-overflow-h js-header-panel" :content="content"  :IsTolltipPopDisabled="IsTolltipPopDisabledGlob"  :headerPageSize="headerPageSize"   :activeIndex="activeIndex"   :navOffsetTop="navOffsetTop"     :indexSS="3"   :hasVideo="!1"  >
                <div class="o-wrapper--valign u-fit u-bg--white" >
                  <div class="c-home__section__bar c-home__section__bar--x u-absolute u-fit-w u-bg--brand-dark u-hide@sm"></div>
                  <div class="c-home__section__bar c-home__section__bar--y u-absolute u-pos-tr u-fit-h u-bg--brand-dark u-hide@sm"></div>
                  <div class="c-home__section__bar c-home__section__bar--x u-absolute u-fit-w u-bg--brand-dark u-hide@sm"></div>
                  <div class="c-home__section__bar c-home__section__bar--y u-absolute u-pos-bl u-fit-h u-bg--brand-dark u-hide@sm"></div>
                   <span class="c-home__section__chapter t-text--xxs t-text--base-bold u-absolute u-color--alpha-white u-hide@sm">{{'0'+(indexSS)}}</span>
                   <img src="../../assets/medias/images/lgoRghPart.svg" class="c-home__section__logo u-absolute u-pos-tl u-marg-t-lg u-marg-l-w1of12 u-zindex--3">
                   <div class="o-wrapper--panel u-zindex--1 u-fit u-bg--black">
                     <img src="../../assets/medias/images/home-03.jpg" class="c-home__section__poster c-home__section__poster--2 o-wrapper--panel u-zindex--2 u-fit u-object-fit-cover">
                     <div class="c-home__section__poster__filter u-absolute u-pos-tl u-zindex--1 u-fit" style="background-color: #ffffff"> </div>
                   </div>

                   <div class="u-absolute u-pos-tl  u-marg-t-mdvh   u-marg-t-mdvh@sm  u-zindex--3 u-marg-l-w1of6 u-marg-l-w2of8@sm u-marg-l-w3of8@xsm">
                     <div class="u-w2of2 u-fit-w@md">
                          <img src="../../assets/medias/images/lgoRghPart.svg" class="c-home__section__logo u-absolute u-pos-tl  u-zindex--3 ">
                         <div class="u-flex t-text--sm t-text--base-bold c-Home--title-lheigt ">
                              <span class="c-number-offset--home t-text--xl--Light   c-home-u-color--gray u-absolute u-pos-bl u-marg-b-xs3@sm">{{'0'+(indexSS)}}</span>
                              <span class="c-home__section__coverage__subsidtitleText  c-home-u-color--gray">{{content.fourth_slide_subtitle}}</span>
                             </div>
                         </div>
                   </div>

                    <div class="c-home__grain o-wrapper--panel u-zindex--2 u-fit u-pointer-none"></div>
                        <div class="c-home__section__fade u-relative u-zindex--3 u-flex u-flex-fd--column@md u-w9of12 u-w9of12@md u-fit-w@sm u-pad-x-w1of12@sm u-pad-x-w0of0@sm">
                              <div class="c-team__content u-marg-t-xxl  u-marg-t-xs@lg u-marg-t-xs@sm u-w2of2 u-w3of4@sm  u-marg-x-w1of12@sm u-w3of4@xsm u-w9of10lg u-marg-t-xxl@sm" >
                                  <section class="u-relative">
                                    <div class="c-team__section-container u-relative  u-pad-y-xxl@md u-pad-y-lg@sm u-pad-x-w0of0@sm">

                                        <div class="c-team__section u-marg-t-xxl u-marg-t-xl@lg u-marg-t-xs@sm" style="margin:0px;">
                                              <div class="u-flex u-flex-fw--wrap u-flex-jc--space-between">
                                                  <a href="javascript:void(0);" data-index="0" class="u-marg-r-cov--wmax@xsm c-team__link-cov c-coverage__link t-link c-home__section__coverage__counterUP u-marg-r-cov--wmax u-marg-r-cov--wmax@xl" >
                                                  <div class="js-photo-container u-relative o-box--14by10 u-marg-b-md u-overflow-h u-force-3d">
                                                    <div class="u-absolute u-pos-t u-zindex--2">
                                                    </div>
                                                      <ul  style="padding-left:0px;">
                                                       <li>
                                                         <img src="/static/coverage/officesIcon.png" alt="Inkript   Industries" title="Inkript   Industries" class="c-team__link__photo__hover u-zindex--1 o-wrapper--panel u-fit u-object-fit-cover u-backface-hidden">
                                                       </li>
                                                       <li  class="c-home__section__description u-w4of5 t-text--xs u-color-icon--gray c-blog__footer__pagination">
                                                           <app-count-up  :isActive="IsActiveCountUp" :startValS="0" :endValS="OfficesVal" :delays="3" ></app-count-up>
                                                       </li>
                                                     </ul>
                                                    </div>
                                                    <div class="u-pad-r-sm"></div>
                                                  </a>
                                                  <a href="javascript:void(0);" data-index="1" class="u-marg-r-cov--wmax@xsm c-team__link-cov c-coverage__link t-link c-home__section__coverage__counterUP u-marg-r-cov--wmax u-marg-r-cov--wmax@xl" >
                                                       <div class=" js-photo-container u-relative o-box--14by10 u-marg-b-md u-overflow-h u-force-3d">
                                                         <div class="u-absolute u-pos-t u-zindex--2">
                                                         </div>
                                                          <ul style="padding-left:0px;">
                                                            <li>
                                                              <img src="/static/coverage/ClientsIcon.png" alt="Inkript   Industries" title="Inkript   Industries" class="c-team__link__photo__hover u-zindex--1 o-wrapper--panel u-fit u-object-fit-cover u-backface-hidden">
                                                            </li>
                                                            <li  class="c-home__section__description u-w4of5 t-text--xs u-color-icon--gray c-blog__footer__pagination">
                                                                <app-count-up  :isActive="IsActiveCountUp" :startValS="0" :endValS="ClientsVal" :delays="3" ></app-count-up>
                                                            </li>
                                                          </ul>
                                                        </div>
                                                           <div class="u-pad-r-sm">
                                                           </div>
                                                      </a>
                                                      <a href="javascript:void(0);" data-index="2" class="u-marg-r-cov--wmax@xsm c-team__link-cov c-coverage__link t-link c-home__section__coverage__counterUP u-marg-r-cov--wmax u-marg-r-cov--wmax@xl" >
                                                        <div class="js-photo-container u-relative o-box--14by10 u-marg-b-md u-overflow-h u-force-3d">
                                                          <div class=" u-absolute u-pos-t u-zindex--2">
                                                          </div>
                                                         <ul style="padding-left:0px;" >
                                                           <li>
                                                               <img src="/static/coverage/EmployessIcon.png" alt="Inkript   Industries" title="Inkript   Industries" class="c-team__link__photo__hover u-zindex--1 o-wrapper--panel u-fit u-object-fit-cover u-backface-hidden">
                                                           </li>
                                                           <li  class="c-home__section__description u-w4of5 t-text--xs u-color-icon--gray c-blog__footer__pagination">
                                                               <app-count-up  :isActive="IsActiveCountUp" :startValS="0" :endValS="EmployeesVal" :delays="1" ></app-count-up>
                                                           </li>
                                                         </ul>
                                                         </div>
                                                         <div class="u-pad-r-sm"></div>
                                                       </a>
                                                       <a href="javascript:void(0);"  class="u-marg-r-cov--wmax@xsm c-team__link-cov c-coverage__link t-link c-home__section__coverage__counterUP u-marg-r-cov--wmax u-marg-r-cov--wmax@xl" >
                                                         <div class="js-photo-container u-relative o-box--14by10 u-marg-b-md u-overflow-h u-force-3d">
                                                           <div class=" u-absolute u-pos-t u-zindex--2"></div>
                                                           <ul style="padding-left:0px;" >
                                                             <li>
                                                                 <img src="/static/coverage/SectorsIcon.png" alt="Inkript   Industries" title="Inkript   Industries" class="c-team__link__photo__hover u-zindex--1 o-wrapper--panel u-fit u-object-fit-cover u-backface-hidden">
                                                             </li>
                                                             <li  class="c-home__section__description u-w4of5 t-text--xs u-color-icon--gray c-blog__footer__pagination">
                                                                 <app-count-up  :isActive="IsActiveCountUp" :startValS="0" :endValS="SectorsVal" :delays="3.5" ></app-count-up>
                                                             </li>
                                                           </ul>
                                                          </div>
                                                            <div class="u-pad-r-sm"></div>
                                                          </a>
                                                    </div>
                                        </div>
                                    </div>
                                  </section>
                              </div>
                        </div>
                          <div class="c-home__line-aside u-absolute u-bg--white" :style="stylesHeight1"></div>
                      <div class="c-home__line-aside c-home__line-aside--bottom u-absolute u-bg--white" :style="stylesHeight1"></div>
                      </div>
                  </app-home-slide>
                  <app-home-slide  inline-template  data-color="clear" class="c-home__section c-home__section--2 o-wrapper--valign u-flex u-flex-ai--center u-fit js-header-panel" :content="content"  :IsTolltipPopDisabled="IsTolltipPopDisabledGlob"     :headerPageSize="headerPageSize"   :activeIndex="activeIndex"   :navOffsetTop="navOffsetTop"     :indexSS="4"   :hasVideo="!1"  >
                    <div class="o-wrapper--valign u-fit u-bg--white" >
                      <div class="c-home__section__bar c-home__section__bar--x u-absolute u-fit-w u-bg--brand-dark u-hide@sm"></div>
                      <div class="c-home__section__bar c-home__section__bar--y u-absolute u-pos-tr u-fit-h u-bg--brand-dark u-hide@sm"></div>
                      <div class="c-home__section__bar c-home__section__bar--x u-absolute u-fit-w u-bg--brand-dark u-hide@sm"></div>
                      <div class="c-home__section__bar c-home__section__bar--y u-absolute u-pos-bl u-fit-h u-bg--brand-dark u-hide@sm"></div>
                       <span class="c-home__section__chapter t-text--xxs t-text--base-bold u-absolute u-color--alpha-white u-hide@sm">{{'0'+(indexSS)}}</span>
                       <img src="../../assets/medias/images/lgoRghPart.svg" class="c-home__section__logo u-absolute u-pos-tl u-marg-t-lg u-marg-l-w1of12 u-zindex--3 u-hide@sm">
                       <div class="o-wrapper--panel  u-fit">
                         <img src="../../assets/medias/images/home-04.jpg" class="c-home__section__poster  o-wrapper--panel  u-fit u-object-fit-cover">

                       </div>
                       <div class="u-absolute u-pos-tl  u-marg-t-mdvh   u-marg-t-mdvh@sm  u-zindex--3 u-marg-l-w1of6 u-marg-l-w2of8@sm u-marg-l-w3of8@xsm">
                         <div class="u-w2of2 u-fit-w@md">
                              <img src="../../assets/medias/images/logo-simple-clear.svg" class="c-home__section__logo u-absolute u-pos-tl  u-zindex--3 ">
                             <div class="u-flex t-text--sm t-text--base-bold c-Home--title-lheigt ">
                                  <span class="c-number-offset--home t-text--xl--Light   c-home-u-color--white u-absolute u-pos-bl u-marg-b-xs3@sm">{{'0'+(indexSS)}}</span>
                                  <span class="c-home__section__coverage__subsidtitleText  u-color--white">Our Presence</span>
                                 </div>
                             </div>
                       </div>

                        <div class="c-home__section__fade u-w2of2 u-fit-w@sm u-pad-l-0@sm u-pad-x-w1of12 u-marg-t-xxl">
                          <div class="u-marg-l-w1of9   u-w4of5   u-w9of10@sm">
                                 <div  class="t-text--md--bold u-color--white rgh-about-title">
                                    Diverse & Dispersed
                                  </div>
                                  <p class="c-home__section__description  u-w2of5 u-w9of10@xl u-w9of10@sm  t-text--md  u-color--white u-pad-t-xs" >Headquartered in Beirut, Lebanon, the group operates via an established international network of offices and distributors.</p>
                                  <div class="parent-wrapper  u-marg-t-lg@sm u-marg-t-xxl u-marg-t-lg" >
                                   <div class="parent u-flex-jc--space-between u-color--white">
                                       <div class="child "  style="cursor:pointer" ><v-popover  :disabled="IsTolltipPopDisabled">Head Office<template slot="popover">Lebanon</template></v-popover></div>
                                       <div class="child"  style="cursor:pointer" ><v-popover @Click :disabled="IsTolltipPopDisabled">Market Coverage<template slot="popover">Europe</br>Middle East</br>Africa</template></v-popover></div>
                                       <div class="child"  style="cursor:pointer"><v-popover :disabled="IsTolltipPopDisabled">Operation Offices<template slot="popover">Lebanon</br>Central Africa</br>Chad</br>Zambia</br>Burundi</br>Nigeria</br>DRC</br>Liberia</br>Ethiopia</br>Morocco</br>San Francisco</template></v-popover></div>
                                       <div class="child" style="cursor:pointer"><v-popover :disabled="IsTolltipPopDisabled">Production Plants<template slot="popover">Lebanon</br>KSA</template></v-popover></div>

                                      </div>
                               </div>

                          </div>

                        </div>

                          <div class="c-home__line-aside u-absolute u-bg--white" :style="stylesHeight1"></div>
                          <div class="c-home__line-aside c-home__line-aside--bottom u-absolute u-bg--white" :style="stylesHeight1"></div>

                          </div>

                      </app-home-slide>
                      <footer class="c-home__footer u-absolute u-pos-b  u-pad-x-w1of12 u-fit-w">
                        <div  class="u-relative u-pad-y-sm">
                        <div  class="u-relative u-marg-b-md u-marg-b-xs@sm">
                           <a  href="javascript:void(0);"  @click="onDotClick(0)"  class="c-footer__link c-footer__scrolltop t-link t-text--xxs t-text-ls--md u-absolute u-relative@sm u-pos-bl u-color--white u-uppercase">
                             <span  class="u-inline-block u-valign-middle" >Top</span>
                           <img src="../../assets/medias/images/icons/arrow-top-gray.svg"   class="c-footer__scrolltop__icon t-icon--arrow-top-white u-inline-block u-valign-bottom"></a>

                                   </div>
                                   <div class="c-line c-line--x u-bg--white u-marg-b-md u-marg-b-xs@sm"></div>
                                   </div>
                      </footer>
</main>
</template>

<script>
import appHomeSlide from '../app-home-slide/index.vue'
export default {
    props: {
      debug: {
          type: Boolean,
          default: !1
      },
        adminContent: {
            type: Object,
            default: function() {}
        },
        globalContent: {
            type: Object,
            default: function() {}
        },
        headerPageSize: {
            type: Array,
            default: function() {}
        }
        ,
        isPopinActive:
        {
          type:Boolean,
          default: !1
        }
    },
    components: {
        'app-home-slide':appHomeSlide
},
    mixins: [],
    data: function() {
        return {
            activeIndex: 0,
            activeRollOverIndex: 0,
            navHeight: 0,
            navOffsetTop: 0,
            IsTolltipPopDisabledGlob:!0
        }
    },
    computed: {
        content: function() {
            return this.adminContent.en.pages.home
        },
        myStylesNavHeight() {
            return {
                height: this.navHeight+'px',
                width:'70px'
            }
        },
        myStylesTransform1() {
            return {
                transform: 'translateY('+100*this.activeRollOverIndex+') translateZ(0) ',

            }
        }
    },
    created: function() {

           this.PIXEL_STEP = 10,
            this.LINE_HEIGHT = 40,
            this.PAGE_HEIGHT = 800,
            this.NBSLIDE = 6,
            this._isWheeling = !1,
            this._isPointerDown = !1,
            this._pointerY = 0,
            this._pointerStartY = 0,
            this.eventHub.$on("resize", this.onResize)

    },
    destroyed: function()
    {
        this.eventHub.$off("resize", this.onResize)

    },
    mounted: function()
    {

            this.eventHub.$emit("page:ready"),
            this.$nav = this.$el.querySelector(".js-nav"),
            this.onResize()

    },
    methods:
    {
        _getFooter: function() {
            return this.adminContent.en["theme-general-settings"].footer_copyright_label.replace("<year>", (new Date).getFullYear())
        },
        GoTop: function(t)
         {
         },
        onMouseWheel: function(t)
         {
          // console.log("this.isPopinActive" +this.isPopinActive);
           if(!this.isPopinActive)
           {
            var e = this;
            t.preventDefault(),
             t.stopPropagation(),
             clearTimeout(this.wheelTimer),
              this.wheelTimer = setTimeout(function() {  e._isWheeling = !1}, 500);

            if (Math.abs(-this.normalizeWheel(t).pixelY) < 10 && (clearTimeout(this.wheelTimer), this._isWheeling = !1), !(this._isWheeling || Math.abs(-this.normalizeWheel(t).pixelY) < 10 || Date.now() - this._lastWheelTime < 1e3))
            {
                this._lastWheelTime = Date.now(),
                 this._wheelEndTimer = setTimeout(function() {clearTimeout(e.wheelTimer), e._isWheeling = !1  }, 1e3),
                 this._isWheeling = !0,
                 this._isScrollFromWheel = !0;
                var n = this.normalizeWheel(t),
                    r = -n.pixelY;
                    //console.log("this is:" +r);
                    if(this.activeIndex<4&&r < 0)
                    {
                      this.onNextSlide()
                    }
                    if(this.activeIndex<=4&&r > 0)
                    {
                      this.onPrevSlide()
                    }
                    //r < 0 ? this.onNextSlide() : r > 0 && this.onPrevSlide()
            }
            }
        },
        onResize: function()
        {
          this.debug&&console.log('On resize start method inside app-page-home');
            this.navHeight = this.$nav.offsetHeight,
            this.navOffsetTop = this.$nav.offsetTop - .5 * this.navHeight
            this.debug&&console.log('On resize start method inside app-page-home End');
        },
        onPrevSlide: function()
        {
            this.activeIndex > 0 && (this.activeIndex -= 1, this.onChangeSlide())
        },
        onNextSlide: function()
        {
            this.activeIndex < this.NBSLIDE - 1 && (this.activeIndex += 1, this.onChangeSlide())
        },
        onDotClick: function(t)
        {
            this.activeIndex = t,
            this.onChangeSlide()
        },
        onDotOver: function(t)
        {
            this.activeRollOverIndex = t
        },
        onDotOut: function()
        {
            this.activeRollOverIndex = this.activeIndex
        },
        onMenuOver: function()
        {

            0 !== this.activeIndex && this.$el.classList.add("is-menu-hover"),
            this.$GetAllSignLogo = document.querySelectorAll(".c-home__section__logo"),
            this.$GetAllSignLogo.forEach(function(navLogoSign) {
                navLogoSign.classList.add("u-hide")
                                                                                            })
        },
        onMenuOut: function()
        {
            this.$el.classList.remove("is-menu-hover"),
            this.$GetAllSignLogo = document.querySelectorAll(".c-home__section__logo"),
            this.$GetAllSignLogo.forEach(function(navLogoSign) {
                navLogoSign.classList.remove("u-hide")
                                                                                            })

        },
        onChangeSlide: function()
        {

          if(this.activeIndex===4)
          {
          this.IsTolltipPopDisabledGlob=!1

          }
          else {
            this.IsTolltipPopDisabledGlob=!0
          }
            this.eventHub.$emit("close:popin"),

            4 === this.activeIndex ? this.$el.classList.add("is-last") : this.$el.classList.remove("is-last"),
            this.activeRollOverIndex = this.activeIndex,
            this.eventHub.$emit("change:slide", this.activeRollOverIndex),
                0 === this.activeIndex ? (this.$el.classList.add("is-first"),
                    this.eventHub.$emit("show:header")) : (this.$el.classList.remove("is-first"),
                    this.eventHub.$emit("hide:header"))

        },
        onTouchDown: function(t)
        {
          if(!this.isPopinActive)
          {
            this._isPointerDown = !0,
            this._pointerStartY = t.touches[0].clientY,
             this._pointerY = this._pointerStartY
           }
        },
        onTouchMove: function(t)
        {
          if(!this.isPopinActive)
          {
            this._isPointerDown && (t.preventDefault(),
             this._pointerY = t.touches[0].clientY)
           }
        },
        onTouchEnd: function(t)
        {
          if(!this.isPopinActive)
          {
              if(this.activeIndex<4)
              {
                  this._isPointerDown &&
                  (this._isPointerDown = !1,  Math.abs(this._pointerStartY - this._pointerY)
                  > 10 && (this._pointerY > this._pointerStartY ? this.onPrevSlide() : this.onNextSlide()))
            }
            if(this.activeIndex==4)
            {
              this._isPointerDown &&
              (this._isPointerDown = !1,  Math.abs(this._pointerStartY - this._pointerY)
              > 10 && (this._pointerY > this._pointerStartY ? this.onPrevSlide() : ''))
            }
          }
        },
        normalizeWheel: function(t)
        {
          //console.log(t);
            return this._sX = 0,
             this._sY = 0,
              this._pX = 0,
              this._pY = 0,
              "detail" in t && (this._sY = t.detail),
               "wheelDelta" in t && (this._sY = -t.wheelDelta / 120),
               "wheelDeltaY" in t && (this._sY = -t.wheelDeltaY / 120),
               "wheelDeltaX" in t && (this._sX = -t.wheelDeltaX / 120),
                "axis" in t && t.axis === t.HORIZONTAL_AXIS && (this._sX = this._sY, this._sY = 0),
                this._pX = this._sX * this.PIXEL_STEP,
                this._pY = this._sY * this.PIXEL_STEP,
                "deltaY" in t && (this._pY = t.deltaY),
                "deltaX" in t && (this._pX = t.deltaX),
                (this._pX || this._pY) && t.deltaMode && (1 == t.deltaMode ? (this._pX *= this.LINE_HEIGHT, this._pY *= this.LINE_HEIGHT) : (this._pX *= this.PAGE_HEIGHT, this._pY *= this.PAGE_HEIGHT)),
                this._pX && !this._sX && (this._sX = this._pX < 1 ? -1 : 1),
                 this._pY && !this._sY && (this._sY = this._pY < 1 ? -1 : 1),
                 {
                spinX: this._sX,
                spinY: this._sY,
                pixelX: this._pX,
                pixelY: this._pY
            }
        }
    }
}

</script>
<style  scoped>

</style>



// WEBPACK FOOTER //
// src/components/app-page-home/index.vue